export const weightClassOptions = [
  { value: "STRAWWEIGHT", label: "STRAWWEIGHT" },
  { value: "FLYWEIGHT", label: "FLYWEIGHT" },
  { value: "BANTAMWEIGHT", label: "BANTAMWEIGHT" },
  { value: "FEATHERWEIGHT", label: "FEATHERWEIGHT" },
  { value: "LIGHTWEIGHT", label: "LIGHTWEIGHT" },
  { value: "WELTERWEIGHT", label: "WELTERWEIGHT" },
  { value: "MIDDLEWEIGHT", label: "MIDDLEWEIGHT" },
  { value: "LIGHT HEAVYWEIGHT", label: "LIGHT HEAVYWEIGHT" },
  { value: "HEAVYWEIGHT", label: "HEAVYWEIGHT" },
  { value: "CATCHWEIGHT", label: "CATCHWEIGHT" },
];
